import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { TemplateActivationEntity } from '../../domain/entities/TemplateActivationEntity'
export class TemplateActivationModel extends TemplateActivationEntity {
  regionIds?: Array<number>
  constructor(dataDto: TemplateActivationEntity) {
    super()
    mapEntityProperties<TemplateActivationModel>(this, dataDto, {
      exclude: ['regions'],
      map: {
        regionIds: dataDto.regions?.map((region) => region.id)
      }
    })
  }
}
